import { fixedFiltersMock } from './fixedFiltersMock';

const LOCAL_STORAGE_KEY_PREFIX = 'search-fixed-filter-';

export const toggleFixedFilter = (urlFilter: string) => {
    if (!fixedFiltersMock.find((mockFixedFilter) => mockFixedFilter.urlFilter === urlFilter)) {
        return;
    }

    if (isFilterSet(urlFilter)) {
        deleteFilter(urlFilter);

        return;
    }

    saveFilter(urlFilter);
};

const saveFilter = (urlFilter: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEY_PREFIX + urlFilter, 'true');
};

const deleteFilter = (urlFilter: string) => {
    localStorage.removeItem(LOCAL_STORAGE_KEY_PREFIX + urlFilter);
};

export const isFilterSet = (urlFilter: string): boolean => {
    const filter = localStorage.getItem(LOCAL_STORAGE_KEY_PREFIX + urlFilter);

    return !!filter;
};

export const clearFixedFilter = () => {
    const keysToRemove: Array<string> = Object.keys(localStorage).filter((key) =>
        key.startsWith(LOCAL_STORAGE_KEY_PREFIX)
    );
    keysToRemove.forEach((key) => localStorage.removeItem(key));
};
